import { get, isFunction } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputErrorMessage } from './InputErrorMessage';

export const SelectInput = ({
    name,
    label,
    className,
    children,
    registerOptions = {},
    options,
    optionsWithKey,
    startsEmpty = true,
    helperText,
    ...props
}: any) => {
    const {
        register,
        formState: { errors },
        watch
    } = useFormContext();
    const error = get(errors, name);
    const values = watch();
    const mappableOptions = () => (isFunction(options) ? options(values) : options);
    const { t } = useTranslation('common');

    return (
        <div className={'form-group' + (className ? ' ' + className : '')} {...props}>
            {label && <label>{label}</label>}
            <select
                {...register(name, registerOptions)}
                className={`form-control ${error ? 'is-invalid' : ''}`}
                name={name}
                {...props}
            >
                {startsEmpty && (
                    <option key="empty" value="">
                        {t('Bitte wählen ...', { ns: 'form' })}
                    </option>
                )}
                {children
                    ? children
                    : optionsWithKey
                      ? optionsWithKey.map((o) => (
                            <option key={`${name}_option_${o.id ?? o.value}`} value={o.id ?? o.value}>
                                {t(o.label, { nsSeparator: null })}
                            </option>
                        ))
                      : mappableOptions()?.map((o) => (
                            <option key={`${name}_option_${o}`} value={o}>
                                {t(o, { nsSeparator: null })}
                            </option>
                        ))}
            </select>
            {helperText && <small className="form-text text-muted">{helperText}</small>}
            <InputErrorMessage name={name} />
        </div>
    );
};
